<template>
  <div>
    <!-- Header -->
    <div
      class="resource-header border-bottom d-flex justify-content-between align-items-start mb-1"
      style="padding-bottom: 0.5rem"
    >
      <div class="tabs-container">
        <slot name="tabs" />
      </div>

      <div class="actions-container d-flex justify-content-between">
        <slot name="actions" />
      </div>
    </div>

    <!-- Form -->
    <b-overlay :show="isLoading" spinner-variant="primary">
      <slot name="form" />
    </b-overlay>
  </div>
</template>

<script>
import { BBreadcrumb, BBreadcrumbItem, BButton, BCard, BOverlay, BTab, BTabs } from 'bootstrap-vue';
import { ValidationObserver } from 'vee-validate';

export default {
  name: 'ResourceFormLayout',
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BButton,
    BCard,
    BTab,
    BTabs,
    ValidationObserver,
    BOverlay,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.resource-header {
  position: sticky;
  left: 0;
  top: 80px;
  padding: 1.3rem 2rem 0;
  background-color: var(--light);
  z-index: 999;
}

@media (max-width: 576px) {
  .resource-header {
    flex-direction: column-reverse !important;
    padding: 1.3rem 0 0 0;

    & > div:not(:first-child) {
      width: 100%;
      margin-bottom: 1rem;
    }
  }
}
</style>
